export function isSpace(str) {
    const reg = /(^\s+)|(\s+$)|\s+/g
    return reg.test(str)
}

export function checkName(rule, value, callback) {
    // const reg = /^(?!.*?[\u3000-\u303F\u4DC0-\u4DFF\u2800-\u28FF\u3200-\u32FF\u3300-\u33FF\u2700-\u27BF\u2600-\u26FF\uFE10-\uFE1F\uFE30-\uFE4F])[\u4e00-\u9fbb\u2E80-\uFE4Fa-zA-Z0-9.`·]+$/;
    const reg = /^[a-zA-Z0-9\u4e00-\u9fa5]+$/;
    if (!reg.test(value)) {
        callback(new Error('请不要输入特殊字符'))
    }else if(validateStrLen(value) > 20){
        callback(new Error('请不要超过20个字符(字母1个字符,文字2个字符)'))
    }
    callback();
}
export function checkShortName(rule, value, callback) {
    // const reg = /^(?!.*?[\u3000-\u303F\u4DC0-\u4DFF\u2800-\u28FF\u3200-\u32FF\u3300-\u33FF\u2700-\u27BF\u2600-\u26FF\uFE10-\uFE1F\uFE30-\uFE4F])[\u4e00-\u9fbb\u2E80-\uFE4Fa-zA-Z0-9.`·]+$/;
    const reg = /^[a-zA-Z0-9\u4e00-\u9fa5]+$/;
    if (!reg.test(value)) {
        callback(new Error('请不要输入特殊字符'))
    }else if(validateStrLen(value) > 10){
        callback(new Error('请不要超过10个字符(字母1个字符,文字2个字符)'))
    }
    callback();
}
export function checkRemark(rule, value, callback) {
    if(validateStrLen(value) > 50){
        callback(new Error('请不要超过50个字符(字母1个字符,文字2个字符)'))
    }
    callback();
}
export function checkKeyword(rule, value, callback) {
    if(validateStrLen(value) > 100){
        callback(new Error('请不要超过100个字符(字母1个字符,文字2个字符)'))
    }
    callback();
}
export function validateStrLen(value) {
    let len = 0;
    for (let i = 0; i < value.length; i++) {
        let c = value.charCodeAt(i);
        //单字节加1
        if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
            len++;
        }
        else {
            len += 2;
        }

    }
    return len;
}
export function checkPassword(rule, value, callback) {
    // const reg = /^(?!.*?[\u3000-\u303F\u4DC0-\u4DFF\u2800-\u28FF\u3200-\u32FF\u3300-\u33FF\u2700-\u27BF\u2600-\u26FF\uFE10-\uFE1F\uFE30-\uFE4F])[\u4e00-\u9fbb\u2E80-\uFE4Fa-zA-Z0-9.`·]+$/;
    // const reg = /^[a-zA-Z0-9\u4e00-\u9fa5]+$/;
    // if (!reg.test(value)) {
    //     callback(new Error('密码是8-20位字符大小写字母及数字'))
    // }else
    if(validateStrLen(value) < 8){
        callback(new Error('请不要小于8个字符(字母1个字符,文字2个字符)'))
    }else if(validateStrLen(value) > 20){
        callback(new Error('请不要超过20个字符(字母1个字符,文字2个字符)'))
    }
    callback();
}

export function checkLoginName(rule, value, callback) {
    // const reg = /^(?!.*?[\u3000-\u303F\u4DC0-\u4DFF\u2800-\u28FF\u3200-\u32FF\u3300-\u33FF\u2700-\u27BF\u2600-\u26FF\uFE10-\uFE1F\uFE30-\uFE4F])[\u4e00-\u9fbb\u2E80-\uFE4Fa-zA-Z0-9.`·]+$/;
    const reg = /^[a-z0-9\u4e00-\u9fa5]+$/;
    if (!reg.test(value)) {
        callback(new Error('登录账号只能是小写字母或数字'))
    }else if(validateStrLen(value) < 6){
        callback(new Error('请不要小于6个字符(字母1个字符,文字2个字符)'))
    }else if(validateStrLen(value) > 20){
        callback(new Error('请不要超过20个字符(字母1个字符,文字2个字符)'))
    }
    callback();
}

export function isPoneAvailable(rule, value, callback) {
    let reg=/^[1][3,4,5,7,8,9][0-9]{9}$/;
    if (!reg.test(value)) {
        callback(new Error('请输入正确格式的手机号码'))
    }
    callback();
}

export function  isEmailAvailable(rule, value, callback) {
    let myreg = /^([a-zA-Z0-9]+[_|\\_|\\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\\_|\\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
    if (!myreg.test(value)) {
        callback(new Error('请输入正确格式的邮箱'))
    }
    callback();
}

export function checkAgreementCode(rule, value, callback) {
    if(validateStrLen(value) > 30){
        callback(new Error('协议编号最多30个字符'))
    }
    callback();
}

export function checkAgreementName(rule, value, callback) {
    if(validateStrLen(value) > 200){
        callback(new Error('协议名称最多200个字符'))
    }
    callback();
}


// 验证是否是手机号或者固定电话
const mobileReg = /^0?(11|12|13|15|16|17|18|19|14)[0-9]{9}$/;

const isPhone = /^(0|4)\d{2,3}-?\d{7,8}$/
export const mobilePhone = (rule, value, callback) => {
   if (value === '') {
       callback(new Error('请输入手机号或固定电话'));
   } else if (!isPhone.test(value) && !mobileReg.test(value)) {
       callback(new Error('请输入正确的手机号或固定电话'));
   } else {
       callback();
   }
}

// 联系人可输入2-20字符
const contacts = /^(?:[\a-\z\A-\Z\u4e00-\u9fa5·]{2,20})$/
export const verifyCntacts = (rule, value, callback) => {
    if (value === '') {
        callback(new Error('请输入联系人'));
    } else if (!contacts.test(value)) {
        callback(new Error('请输入正确的联系人名称'));
    } else {
        callback();
    }
 }

// 15位数字包括下划线
const num15 = /^[0-9-]*$/
export const mobilePhone15 = (rule, value, callback) => {
    if (value === '') {
        callback(new Error('请输入手机号或固定电话'));
    } else if (!num15.test(value)) {
        callback(new Error('请输入正确的手机号或固定电话'));
    } else {
        callback();
    }
}

